// extracted by mini-css-extract-plugin
export default {"telephoneLink":"input-request-module-telephoneLink--Ox4ch","secondText":"input-request-module-secondText--fwzjL"};